<template>
  <div>
    <TableRow>
      <Copy element="div" bold slot="left">
        {{ $t('cs.analysis.carePossibility.modal-2.table.row-1') }}
      </Copy>
      <template slot="right">{{ formatNumber(examplePrice, 0) }} €</template>
    </TableRow>

    <TableRow>
      <Copy element="div" bold slot="left">
        {{ $t('cs.analysis.carePossibility.modal.table.row-2') }}
      </Copy>
      <template slot="right">{{ -formatNumber(facts.pflegegeld, 0) }} €</template>
    </TableRow>

    <TableRow>
      <Copy element="div" bold slot="left">
        {{ $t('cs.analysis.carePossibility.modal.table.row-3') }}
      </Copy>
      <template slot="right">{{ -formatNumber(facts.entlastungsbetrag, 0) }} €</template>
    </TableRow>

    <Copy size="s">{{ $t('cs.analysis.carePossibility.modal-2.example.legal') }}</Copy>

    <Row class="u-padding__vertical--3">
      <Col :xs="10">
        <Headline size="s" noMargin>
          {{ $t('cs.analysis.carePossibility.modal.example.personalContribution') }}
        </Headline>
      </Col>
      <Col :xs="2" right>
        <Headline color="tertiaryDark" size="s" noMargin>{{ formatNumber(result, 0) }} €</Headline>
      </Col>
    </Row>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

import TableRow from './TableRow';

import { formatNumber } from '@/helpers/formatter';

export default {
  name: 'TableHours',
  props: {
    facts: Object,
  },
  components: {
    Headline,
    Copy,
    Row,
    Col,
    TableRow,
  },
  data() {
    const examplePrice = 2500;
    return {
      formatNumber,
      examplePrice,
      result: examplePrice - this.facts.pflegegeld - this.facts.entlastungsbetrag,
    };
  },
};
</script>
